import React, { Fragment } from 'react'

const Table = props => {
  const {
    className,
    ...tableProps
  } = props

  const tableClass = `collapse w-100 ${className || ''}`

  return (
    <table className={tableClass} {...tableProps} />
  )
}

const Head = props => (
  <thead>
    {props.children}
  </thead>
)

const Header = props => {
  const cn = props.onClickHeader
    ? `st-pb3 norms-20 fw5 dark-gray tl pointer ${props.className}`
    : `st-pb3 norms-20 fw5 dark-gray tl ${props.className}`

  const arrow = props.sorting
    ? (
      <Fragment>
        <img className={`v-mid ml2${props.sortOrder === -1 ? ' dn' : ''}`} src='assets/chevron-down.png' style={{ width: '0.625rem' }} />
        <img className={`v-mid ml2${props.sortOrder === 1 ? ' dn' : ''}`} src='assets/chevron-up.png' style={{ width: '0.625rem' }} />
      </Fragment>
    )
    : (
      <img className={`v-mid ml2 o-20`} src='assets/chevron-up.png' style={{ width: '0.625rem' }} />
    )

  return (
    <th className={cn} onClick={props.onClickHeader}>
      {props.children}
      {arrow}
    </th>
  )
}

const Body = props => <tbody {...props} />

const Row = props => <tr {...props} />

const DataNoBorder = props => {
  const {
    className,
    ...restProps
  } = props

  return (
    <td {...restProps} className={`dark-gray norms-16 ${props.className}`} />
  )
}

const Data = props => {
  const {
    className,
    ...restProps
  } = props

  return (
    <td {...restProps}
      className={`dark-gray norms-16 pv3 ph1 bb b--mid-gray ${props.className}`}
    />
  )
}

export default {
  Table,
  Header,
  Head,
  Body,
  Row,
  Data,
  DataNoBorder,
}
